import { motion } from "framer-motion";

export default function Contact() {
  return (
    <motion.section
      id="contact"
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="py-24 text-center"
    >

      <h2 className="text-4xl font-bold mb-6">
        Let's Build Something
      </h2>

      <p className="text-zinc-400 max-w-2xl mx-auto leading-relaxed mb-10">
        Interested in development, collaboration,
        frontend engineering or software systems?
        Feel free to reach out.
      </p>

      <div className="flex justify-center gap-4 flex-wrap">

        <a
          href="mailto:developwithmanish@gmail.com"
          className="bg-white text-black px-6 py-3 rounded-2xl font-semibold hover:scale-105 transition"
        >
          Email Me
        </a>

        <a
          href="https://github.com/developwithmanish"
          target="_blank"
          rel="noreferrer"
          className="border border-zinc-700 px-6 py-3 rounded-2xl hover:bg-zinc-900 transition"
        >
          GitHub
        </a>

      </div>

    </motion.section>
  );
}